import { IComponentOptions, IController } from "angular";

export class HelpCenterController implements IController {
  isHighlighted: boolean;
}

export const HelpCenterComponent: IComponentOptions = {
  templateUrl: require("./help-center.jade"),
  controller: HelpCenterController,
  bindings: {
    isHighlighted: "<",
  },
};
